const key = process.env.VUE_APP_CARTO_API_KEY;

export default {
  normal: `https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}{r}.png?key=${key}`,
  satellite: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
  labels: `https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}.png?key=${key}`,
  dark: `https://{s}.basemaps.cartocdn.com/dark_nolabels/{z}/{x}/{y}{r}.png?key=${key}`,
  darkLabels: `https://{s}.basemaps.cartocdn.com/dark_only_labels/{z}/{x}/{y}{r}.png?key=${key}`,
};
